import React from "react";
import FormContext, { FormProvider } from "src/context/FormContext";
import { Detail } from "src/templates";
import { ContentSection } from "./ContentSection";
import { useNewPremiseEffect } from "./hooks/useNewPremiseEffect";
import { NewPremiseDetailProps, NewPremiseProps } from "./types";
import { AlertBannerSection } from "./AlertBannerSection";
import { SnackbarSection } from "./SnackbarSection";
import { SidebarSection } from "./SidebarSection";
import { ExposeFormContext } from "src/components/WindowRuntime";

export const NewPremiseDetail = ({
  premiseBlockRef,
  accountBlockRef,
  electricityBlockRef,
  gasLineBlockRef,
  gasBothBlockRef,
  gasMeterBlockRef,
  closeTransferBlockRef,
  children,
  ...restProps
}: NewPremiseDetailProps) => {
  const {
    formState: { address },
  } = React.useContext(FormContext);
  return (
    <Detail
      pageTitleSection={"New premises"}
      addressSection={address}
      sidebarSection={
        <SidebarSection
          premiseBlockRef={premiseBlockRef}
          accountBlockRef={accountBlockRef}
          electricityBlockRef={electricityBlockRef}
          gasLineBlockRef={gasLineBlockRef}
          gasBothBlockRef={gasBothBlockRef}
          gasMeterBlockRef={gasMeterBlockRef}
          closeTransferBlockRef={closeTransferBlockRef}
        />
      }
      alertBannerSection={<AlertBannerSection />}
      snackbarSection={<SnackbarSection />}
      data-id={restProps["data-id"]}
    >
      {children}
    </Detail>
  );
};

export const NewPremiseContainer = (props: NewPremiseProps) => {
  const highOrderProps = useNewPremiseEffect(props);
  return (
    <NewPremiseDetail data-id={props["data-id"]} {...highOrderProps}>
      <ContentSection {...highOrderProps} />
    </NewPremiseDetail>
  );
};

export const NewPremise: React.FC<NewPremiseProps> = (
  props: NewPremiseProps
) => (
  <FormProvider>
    <ExposeFormContext />
    <NewPremiseContainer {...props} data-id="newPremiseDetail" />
  </FormProvider>
);

export * from "./types";
